import React from 'react';
import { Search, Bell, User } from 'lucide-react';
import { ZipCodeFilter } from './ZipCodeFilter';
export function TopBar() {
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 sticky top-0 z-10" data-id="element-332">
      <div className="flex items-center" data-id="element-333">
        {/* Mobile menu trigger could go here */}
        <h2 className="text-xl font-bold text-navy-900 tracking-tight" data-id="element-334">
          Preço Justo
          <span className="ml-3 text-sm font-normal text-slate-500 border-l border-slate-300 pl-3 hidden sm:inline-block" data-id="element-335">
            Inteligência de Mercado
          </span>
        </h2>
      </div>

      <div className="flex items-center space-x-6" data-id="element-336">
        <div className="hidden md:block" data-id="element-337">
          <ZipCodeFilter data-id="element-338" />
        </div>

        <div className="relative hidden md:block" data-id="element-339">
          <input type="text" placeholder="Buscar..." className="pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900 focus:border-transparent w-64" data-id="element-340" />
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-341" />
        </div>

        <button className="relative p-2 text-slate-500 hover:text-navy-900 transition-colors" data-id="element-342">
          <Bell className="h-5 w-5" data-id="element-343" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full border border-white" data-id="element-344"></span>
        </button>

        <div className="flex items-center space-x-3 border-l border-slate-200 pl-6" data-id="element-345">
          <div className="text-right hidden sm:block" data-id="element-346">
            <p className="text-sm font-medium text-navy-900" data-id="element-347">Admin User</p>
            <p className="text-xs text-slate-500" data-id="element-348">Gerente de Pricing</p>
          </div>
          <div className="h-9 w-9 bg-navy-900 rounded-full flex items-center justify-center text-white" data-id="element-349">
            <User className="h-5 w-5" data-id="element-350" />
          </div>
        </div>
      </div>
    </header>;
}